import React from 'react'

import BusinessIcon from '@tecuity/sos-icons/react/business'
import StampIcon from '@tecuity/sos-icons/react/stamp'
import ShieldIcon from '@tecuity/sos-icons/react/shield'
import CapitalIcon from '@tecuity/sos-icons/react/capital'
import CharityIcon from '@tecuity/sos-icons/react/charity'
import ToolsIcon from '@tecuity/sos-icons/react/tools'
import Search from '@tecuity/sos-icons/react/search'
import UserGroup from '@tecuity/sos-icons/react/user-group'
import User from '@tecuity/sos-icons/react/user'
import Gears from '@tecuity/sos-icons/react/gears'
import Document from '@tecuity/sos-icons/react/document'
import Calendar from '@tecuity/sos-icons/react/calendar'

const ICONS = {
  business: <BusinessIcon />,
  stamp: <StampIcon />,
  shield: <ShieldIcon />,
  capital: <CapitalIcon />,
  capitol: <CapitalIcon />,
  charity: <CharityIcon />,
  tools: <ToolsIcon />,
  search: <Search />,
  userGroup: <UserGroup />,
  user: <User />,
  gears: <Gears />,
  document: <Document />,
  calendar: <Calendar />,
}

export default ICONS

export const iconList = Object.keys(ICONS)

export const FORM_MANAGER_ICON_KEYS = ['business', 'shield', 'tools', 'capital', 'charity', 'stamp']
export const MISC_FORM_MANAGER_ICON_KEYS = ['business', 'shield', 'tools', 'capitol', 'charity', 'stamp']
